import { Controller } from "@hotwired/stimulus"

// Ticks a live local date-time (dd-mm-yyyy HH:MM) into this element — the
// timestamp a new log comment will carry. Minutes only (no seconds).
export default class extends Controller {
  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 15000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    const d = new Date()
    const p = (n) => String(n).padStart(2, "0")
    this.element.textContent =
      `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
  }
}
